import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  List,
  ListItem,
  Button,
  Box,
  ListItemIcon,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

type PricingCardProps = {
  title: string;
  price: string;
  period: string;
  description: string;
  features: string[];
  ctaText: string;
  trialInfo?: string;
  active?: boolean;
  disabled?: boolean;
  onClick: () => void;
};

const PricingCard = ({
  title,
  price,
  period,
  description,
  features,
  ctaText,
  trialInfo,
  onClick,
  active = false,
  disabled = false,
}: PricingCardProps) => {
  return (
    <Card
      sx={{
        margin: 'auto',
        maxWidth: '300px',
        borderRadius: 4,
        boxShadow: active ? 6 : 2,
        transition: '0.3s',
        '&:hover': {
          boxShadow: 8,
        },
      }}
    >
      <CardHeader
        sx={{ paddingBottom: '0' }}
        title={
          <Typography variant="h6" fontWeight="bold" textAlign="center">
            {title}
          </Typography>
        }
      />
      <CardContent>
        <Box textAlign="center">
          <Typography variant="h4" fontWeight="200">
            {price}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            {period}
          </Typography>
          {trialInfo && (
            <Typography
              variant="body2"
              sx={{
                mt: 1,
                color: '#ffffffff',
                fontWeight: 'bold',
                backgroundColor: '#10b981',
                padding: '4px 12px',
                borderRadius: 2,
                display: 'inline-block',
              }}
            >
              {trialInfo}
            </Typography>
          )}
        </Box>

        <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>
          {description}
        </Typography>
        <List dense>
          {features.map((feature, idx) => (
            <ListItem key={idx}>
              <ListItemIcon sx={{ minWidth: 24 }}>
                <CheckIcon fontSize="small" color="primary" />
              </ListItemIcon>
              <Typography variant="body2">{feature}</Typography>
            </ListItem>
          ))}
        </List>

        <Box mt={2} textAlign="center">
          <Button
            variant={active ? 'contained' : 'outlined'}
            color="primary"
            onClick={onClick}
            disabled={disabled}
            fullWidth
          >
            {ctaText}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default PricingCard;
